import React from "react";

import Button from "components/ui/Button";
import { formatDate, formatNumber } from "lib/format";

const STATUS = {
  success: ["Paid", "green"],
  pending: ["Awaiting payment", "orange"],
  failed: ["Failed", "red"],
  failure: ["Failed", "red"],
};

function OrderRow({ order, meta }) {
  const [label, tone] = STATUS[order.status] ?? [order.status, "orange"];
  return (
    <div className="yc-tx-row">
      <div className="yc-tx-class">
        {meta.course_thumbnail ? <img src={meta.course_thumbnail} alt="" /> : <span className="yc-tx-thumb" />}
        <div>
          <p className="yc-tx-name">{meta.course_name ?? "Loading…"}</p>
          <p className="yc-muted yc-tx-id">Order #{order.id}</p>
        </div>
      </div>
      <span className="yc-tx-cell" data-label="Date">
        {order.created_at ? formatDate(order.created_at) : "–"}
      </span>
      <span className="yc-tx-cell yc-tx-amount" data-label="Amount">
        RM {formatNumber(meta.course_price ?? 0)}
      </span>
      <span className="yc-tx-cell" data-label="Status">
        <span className={`yc-tag yc-tag--${tone}`}>{label}</span>
      </span>
      <span className="yc-tx-action">
        {order.status === "success" && (
          <Button size="sm" to={`/courses/${order.course_id}`}>View class</Button>
        )}
        {order.status === "pending" && order.snap_url && (
          <Button size="sm" href={order.snap_url}>Pay now</Button>
        )}
        {/* Manual payment: the class's join page shows how to pay again. */}
        {order.status === "pending" && !order.snap_url && (
          <Button size="sm" variant="secondary" to={`/joined/${order.course_id}`}>How to pay</Button>
        )}
      </span>
    </div>
  );
}

export default function OrderTable({ orders, metaOf }) {
  return (
    <div className="yc-card yc-tx">
      <div className="yc-tx-head" aria-hidden="true">
        <span>Class</span>
        <span>Date</span>
        <span>Amount</span>
        <span>Status</span>
        <span />
      </div>
      {orders.map((order) => (
        <OrderRow key={order.id} order={order} meta={metaOf(order)} />
      ))}
    </div>
  );
}
